import { render, staticRenderFns } from "./SpkDetailModals.vue?vue&type=template&id=2dd795b6&"
import script from "./SpkDetailModals.vue?vue&type=script&lang=js&"
export * from "./SpkDetailModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports